interface GestureEvent extends Event {
    scale?: number;
    clientX?: number;
    clientY?: number;
    screenX?: number;
    screenY?: number;
}

// eslint-disable-next-line max-len
// Adapted from https://github.com/openstreetmap/iD/blob/d01bb7870772f8f8a73ccf660708ae094502da2a/modules/renderer/map.js#L345
export default function addSafariPinchZoom(map: mapboxgl.Map) {
    let scale = 1;
    let lastScale = 0;
    const canvas = map.getCanvas();

    if (!canvas || !canvas.addEventListener) return;

    canvas.addEventListener('gesturestart', (event: Event) => {
        event.preventDefault();
        lastScale = 0;
    });
    canvas.addEventListener('gesturechange', (event: GestureEvent) => {
        event.preventDefault();
        if (!event.scale) return;

        lastScale = scale;
        scale = event.scale;

        const wheelEvent = new WheelEvent('wheel', {
            deltaMode: 0,
            deltaY: (scale > lastScale) ? -4 : 4,
            clientX: event.clientX,
            clientY: event.clientY,
            screenX: event.screenX,
            screenY: event.screenY,
        });

        map.getCanvasContainer().dispatchEvent(wheelEvent);
    });
}
